<div>
  <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 16px">
    <mat-label>CNPJ</mat-label>
    <input
      matInput
      mask="00.000.000/0000-00"
      [formControl]="orgForm.controls.cnpj"
      name="cnpj"
    />
    <mat-error>
      {{ checkForErrorsIn(orgForm.controls.cnpj) }}
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 16px">
    <mat-label>Nome</mat-label>
    <input matInput [formControl]="orgForm.controls.name" name="name" />
    <mat-error>
      {{ checkForErrorsIn(orgForm.controls.name) }}
    </mat-error>
  </mat-form-field>
  <button
    matButton
    [disabled]="isLoading | async"
    color="primary"
    (click)="onSubmit()"
  >
    @if (isLoading | async) {
      <mat-progress-spinner
        diameter="20"
        mode="indeterminate"
        color="accent"
        style="vertical-align: middle"
      ></mat-progress-spinner>
    }
    Salvar
  </button>
</div>
